import { getActivePinia } from 'pinia';
import { Parser } from '~/api';
import { ScheduleCondition, ScheduleTask } from '~/api/models';
import { useModelsStore } from '~/stores';
import RequestService from './request';

interface CreateTaskRequest {
    action: string;
    time_offset: number;
    payload?: string;
    conditions?: ScheduleCondition[];
}

interface UpdateTaskRequest extends CreateTaskRequest {
    id: number;
}

interface DeleteTaskRequest {
    id: number;
}

interface ReorderTasksRequest {
    order: number[];
}

class ScheduleTasksService {
    create(data: CreateTaskRequest): Promise<ScheduleTask> {
        return RequestService.post('/servers/:server/schedules/:schedule/tasks', data)
            .then(Parser.parse)
            .then((task: ScheduleTask) => {
                const modelsStore = useModelsStore();
                modelsStore.refreshModel('schedule');

                return task;
            });
    }

    update(data: UpdateTaskRequest): Promise<ScheduleTask> {
        return RequestService.patch(`/servers/:server/schedules/:schedule/tasks/${data.id}`, data)
            .then(Parser.parse)
            .then((task: ScheduleTask) => {
                const modelsStore = useModelsStore();
                modelsStore.refreshModel('schedule');

                return task;
            });
    }

    delete(data: DeleteTaskRequest): Promise<void> {
        return RequestService.delete(`/servers/:server/schedules/:schedule/tasks/${data.id}`).then(() => {
            const modelsStore = useModelsStore(getActivePinia());
            modelsStore.refreshModel('schedule');
        });
    }

    reorder(data: ReorderTasksRequest): Promise<void> {
        return RequestService.put('/servers/:server/schedules/:schedule/tasks/reorder', data).then(() => {
            const modelsStore = useModelsStore();
            modelsStore.refreshModel('schedule');
        });
    }
}

export default new ScheduleTasksService();
